import { render, staticRenderFns } from "./OrderNoteEditor.vue?vue&type=template&id=1922972b&scoped=true&"
import script from "./OrderNoteEditor.vue?vue&type=script&lang=js&"
export * from "./OrderNoteEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrderNoteEditor.vue?vue&type=style&index=0&id=1922972b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1922972b",
  null
  
)

export default component.exports